export const AUTH_ERROR_CODE_QUERY_PARAM = 'authError';
export const AUTH_ERROR_REASON_QUERY_PARAM = 'reason';
export const AUTH_DEFAULT_LOGIN_REDIRECT_URL = '/app/overview';
